const baseUrl = '/amenities';
const baseUrlCommonArea = '/commonareaamenities';
export const amenitiesRoutes = {
  baseUrl: "".concat(baseUrl),
  baseUrlCommonArea: "".concat(baseUrlCommonArea)
};